export default "https://storage.googleapis.com/prepweb-prod/dist/6d9dcf1d4d5cf64d09589214a6e1e811.svg";